<template>
  <v-container fluid>
    <v-row no-gutters dense class="mt-4">
      <v-col>
        <tj-search-bar :text="searchTerm" @search="onSearch" />
      </v-col>
    </v-row>

    <v-row v-if="hasResult">
      <v-col cols="12" :md="showFilters? 9:12">
        <tj-info-bar
          ref="infoBar"
          class="my-2 transparent"
          elevation="0"
          :sort-by="sortField"
          :sort-order="sortDirection"
          :total="total"
          :page-size="resultsPerPage"
          :page="page"
          :view-mode="viewMode"
          :show-filters="showFilters"
          :sort-fields="sortFields"
          :view-modes="viewModes"
          :paging-sizes="pagingSizes"
          @update:sort-by="onSortBy"
          @update:sort-order="onSortOrder"
          @update:view-mode="onViewMode"
          @update:page-size="onPageSize"
          @update:show-filters="onToggleFilters"
        />

        <div>
          <component
            :class="{'mx-1':isTableMode}"
            :is="resultViewer"
            :itens="resultList"
            :outlined="isTableMode"
            :current-item="currentItem"
            @view="onViewItem"
          />
          <tj-paging-overlay v-if="showPagingOverlay" @prev="onMovePrev" @next="onMoveNext" />
        </div>

        <tj-pager
          v-intersect="onIntersect"
          class="my-2"
          :size="resultsPerPage"
          :total="total"
          :page="page"
          @page-changed="onPage"
        />
      </v-col>

      <v-col class="d-sm-none d-md-block" cols="0" md="3" v-if="showFilters">
        <tj-facet-list ref="facets" 
          :facets="allFacets" 
          @filter="onFilter" 
          @close="onCloseFacet" 
          @close-all="onCloseAllFacets" 
          @open-all="onOpenAllFacets" />
      </v-col>

    </v-row>

    <v-row v-if="!hasResult" dense>
      <v-col>
        <div v-if="hasSearchTerm" class="text-h6 text-center">
          Nenhum item encontrado
        </div>
        <div v-if="!hasSearchTerm" class="text-h6 text-center">
          Especifique algo para pesquisar
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { ElasticService, utils } from "@/service/elastic-service.js";
import elastic from "@/config/elastic.js";
import {cmd, api} from "../service/app-state.js"

import "@/components/tj-search-bar.vue";
import "@/components/tj-nav-drawer.vue";
import "@/components/tj-facet-list.vue";
import "@/components/tj-table-result.vue";
import "@/components/tj-card-result.vue";
import "@/components/tj-full-result.vue";
import "@/components/tj-info-bar.vue";
import "@/components/tj-dropdown.vue";
import "@/components/tj-pager.vue";
import "@/components/tj-paging-overlay.vue"

export default Vue.component("tj-app", {

  data() {
    return {
      pagerVisible: false
    };
  },

  computed: {
    results(){
      return this.$store.state.results
    },

    resultList(){
      return this.$store.getters.formatedResults
    },

    allFacets(){
      return this.$store.getters.formatedFacets
    },

    sortFields(){
      return this.$store.state.sortFields
    },

    viewModes(){
      return this.$store.state.viewModes
    },

    pagingSizes(){
      return this.$store.state.pagingSizes
    },

    searchTerm(){
      return this.$store.state.searchTerm
    },

    viewMode(){
      return this.$store.state.viewMode
    },

    sortField(){
      return this.$store.state.sortField
    },

    sortDirection(){
      return this.$store.state.sortDirection
    },

    page(){
      return this.$store.state.page
    },

    resultsPerPage(){
      return this.$store.state.resultsPerPage
    },

    pageCount(){
      return this.$store.state.pageCount
    },

    total(){
      return this.$store.state.total
    },

    showFilters(){
      return this.$store.state.showFilters
    },

    currentItem(){
      return this.$store.state.currentItem
    },

    showPagingOverlay(){
      return !this.pagerVisible && (this.pageCount > 1)
    },

    hasSearchTerm(){
      return this.searchTerm != null && this.searchTerm.length > 0
    },

    hasResult() {
      return this.results != null && this.results.length > 0;
    },

    isTableMode() {
      return this.viewMode === "table";
    },

    resultViewer() {
      switch (this.viewMode) {
        case "full":
          return "tj-full-result";
        case "card":
          return "tj-card-result";
        default:
          return "tj-table-result";
      }
    }
  },

  watch: {

  },

  created() {
    let  service = new ElasticService(elastic, this);
    this.service = service
    service.utils = utils
    this.$store.commit(cmd.SET_ELASTIC_SERVICE, service)
    this.load(service.init());
  },

  mounted() {
    window.xView = this;
    this.service.reload();
  },

  methods: {

    changeFacetState(facet, closed){
      this.$store.facets.changeState(facet, closed)
    },

    load(state) {
      state = state || {}
      this.$store.commit(cmd.SET_SEARCH_TERM, state.searchTerm)
      this.$store.commit(cmd.SET_SORT_FIELD, state.sortField)
      this.$store.commit(cmd.SET_SORT_DIRECTION, state.sortDirection)
      this.$store.commit(cmd.SET_RESULTS_PER_PAGE, state.resultsPerPage)
      this.$store.commit(cmd.IMPORT_RAW_FILTERS, state.filters)
      this.$store.commit(cmd.SET_FACETS, state.facets)
    },

    onPageSize(v) {
      this.$store.dispatch(api.CHANGE_PAGE_SIZE, v)
    },

    onSortBy(v) {
      console.log("onSortBy", v)
      this.$store.dispatch(api.CHANGE_SORT_COLUMN, v)
    },

    onSortOrder(v) {
      this.$store.dispatch(api.CHANGE_SORT_ORDER, v);
    },

    onViewMode(v) {
      //console.log("onViewMode", v);
      this.$store.commit(cmd.SET_VIEW_MODE, v)
    },

    onPage(v) {
      this.$store.dispatch(api.GOTO_PAGE, v)
    },

    onFilter({ key, value, state }) {
      //console.log("onFilter", { key, value, state });
      let facet = this.$store.getters.getFacetById(key)
      this.$store.dispatch(api.ADD_REMOVE_FILTER, {facet, filter: value, value:state})
    },

    onToggleFilters() {
      this.$store.commit(cmd.SET_SHOW_FILTERS, !this.showFilters);
    },

    onStateChange(state) {
      console.log("onStateChange", state)
      
      this.$store.commit(cmd.SET_FACETS, state.facets)
      this.$store.commit(cmd.IMPORT_RAW_FILTERS, state.filters)
      if(state.meta){
        this.$store.commit(cmd.IMPORT_PAGINATION, (state.meta || {}).page)
      } else {
        this.$store.commit(cmd.SET_PAGE_COUNT, state.totalPages)
        this.$store.commit(cmd.SET_RESULTS_PER_PAGE, state.resultsPerPage)
        this.$store.commit(cmd.SET_TOTAL, state.totalResults)
        this.$store.commit(cmd.SET_PAGE, state.current)
      }
      this.$store.commit(cmd.SET_RESULTS, state.results)
      this.$emit("state-change")
    },

    onSearch(text) {
      this.$store.dispatch(api.SEARCH, text)
    },

    onViewItem(item){
      this.$emit("view", item)
    },

    onCloseFacet(facet, closed){
      this.$store.commit(cmd.CLOSE_FACET, {facet, closed})
    },

    onCloseAllFacets(){
      this.$store.commit(cmd.CLOSE_ALL_FACETS)
    },

    onOpenAllFacets(){
      this.$store.commit(cmd.OPEN_ALL_FACETS)
    },
    
    onIntersect(entries){
      this.pagerVisible = entries[0].isIntersecting
    },

    onMovePrev(){
      if(this.page > 1){
        this.onPage(this.page-1)
      }
    },

    onMoveNext(){
      if(this.page < this.pageCount){
        this.onPage(this.page + 1)
      }
    }


  }
});
</script>
